import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from './session-storage.service';

export interface IAuthService {
  getToken(): string | null;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService implements IAuthService{

  constructor(private router: Router, private sessionStorageService: SessionStorageService) {
  }

  getToken(): string| null{
    return this.sessionStorageService.getSessionItem('oab-profile');
  }

  logout(): void {
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }

}
